import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatTableModule } from '@angular/material/table';
import { MatToolbarModule } from '@angular/material/toolbar';
import { AgrPageToolbarModule, AgrFilterModule } from '@next/core-lib/components';

import { AgrDialogModule } from '@next/core-lib/dialog';
import { AgrFormModule } from '@next/core-lib/form';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { OverviewComponent } from './components/overview/overview.component';
import { SoilAnalysisDialogComponent } from './components/soil-analysis-dialog/soil-analysis-dialog.component';
import { SoilAnalysisEffects } from './store/soil-analysis.effects';
import { soilAnalysisReducer } from './store/soil-analysis.reducer';
import { SharedModule } from '../shared/shared.module';

@NgModule({
  declarations: [OverviewComponent, SoilAnalysisDialogComponent],
  imports: [
    CommonModule,
    FormsModule,
    MatTableModule,
    MatIconModule,
    MatPaginatorModule,
    MatToolbarModule,
    MatInputModule,
    MatSlideToggleModule,
    MatSelectModule,
    MatIconModule,
    MatButtonModule,
    AgrDialogModule,
    SharedModule,
    AgrPageToolbarModule,
    MatAutocompleteModule,
    AgrFilterModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    AgrFormModule,
  ],
  providers: [
    provideState('soilAnalysis', soilAnalysisReducer),
    provideEffects([SoilAnalysisEffects]),
  ],
})
export class SoilAnalysisModule {}
